/* Wishlist (vanilla JS) — no Liquid, safe for Shopify assets */
(function () {
  "use strict";

  var STORAGE_KEY = "wishlist";

  // --- helpers
  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }
  function setList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list || []));
  }
  function byTitle(list, title) {
    return list.find(function (i) { return i && i.productTitle === title; });
  }

  // --- SVG renderers
  function heartFilledSVG() {
    return (
      '<svg width="31.2" height="31.2" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">' +
      '<circle cx="13" cy="13" r="13" fill="#ffffff"/>' +
      '<g transform="translate(4.1,3.8) scale(0.78)">' +
      '<path d="M19.3 5.71C18.84 5.25 18.29 4.88 17.69 4.63C17.09 4.38 16.44 4.25 15.79 4.25C15.14 4.25 14.49 4.38 13.89 4.63C13.29 4.88 12.74 5.25 12.28 5.71L12 6L11.72 5.72C10.79 4.79 9.53 4.27 8.22 4.27C6.91 4.27 5.65 4.79 4.72 5.72C3.8 6.65 3.29 7.91 3.29 9.22C3.29 10.53 3.8 11.79 4.72 12.72L11.49 19.51C11.63 19.65 11.82 19.73 12.02 19.73C12.22 19.73 12.41 19.65 12.55 19.51L19.32 12.72C20.24 11.78 20.75 10.52 20.74 9.21C20.74 7.9 20.22 6.64 19.3 5.71Z" fill="#FF0000"/></g></svg>'
    );
  }
  function heartEmptySVG() {
    return (
      '<svg width="31.2" height="31.2" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">' +
      '<circle cx="13" cy="13" r="13" fill="#ffffff"/>' +
      '<g transform="translate(4.1,3.8) scale(0.78)">' +
      '<path d="M19.3 5.71C18.84 5.25 18.29 4.88 17.69 4.63C17.09 4.38 16.44 4.25 15.79 4.25C15.14 4.25 14.49 4.38 13.89 4.63C13.29 4.88 12.74 5.25 12.28 5.71L12 6L11.72 5.72C10.79 4.79 9.53 4.27 8.22 4.27C6.91 4.27 5.65 4.79 4.72 5.72C3.8 6.65 3.29 7.91 3.29 9.22C3.29 10.53 3.8 11.79 4.72 12.72L11.49 19.51C11.63 19.65 11.82 19.73 12.02 19.73C12.22 19.73 12.41 19.65 12.55 19.51L19.32 12.72C20.24 11.78 20.75 10.52 20.74 9.21C20.74 7.9 20.22 6.64 19.3 5.71Z" fill="#1C1B1B"/></g></svg>'
    );
  }

  // --- PDP toggle
  function toggleWishlist() {
    var titleEl = document.querySelector("[data-product-title]");
    var imgEl   = document.querySelector("[data-product-image]");
    var priceEl = document.querySelector("[data-product-price]");
    var urlEl   = document.querySelector("[data-product-url]");

    if (!titleEl || !imgEl || !priceEl || !urlEl) {
      console.error("Wishlist: product data hooks missing on page");
      return;
    }

    var data = {
      productTitle: (titleEl.textContent || "").trim(),
      productImg: imgEl.getAttribute("src") || "",
      productPrice: (priceEl.textContent || "").trim(),
      productUrl: urlEl.getAttribute("href") || location.pathname
    };

    var list = getList();
    var existing = byTitle(list, data.productTitle);

    if (existing) {
      list = list.filter(function (i) { return i.productTitle !== data.productTitle; });
    } else {
      list.push(data);
    }
    setList(list);
    updateWishlistButtonState(data.productTitle);
  }

  // --- button state on PDP
  function updateWishlistButtonState(productTitle) {
    var btn = document.querySelector(".wishlist_button");
    if (!btn) return;

    var list = getList();
    var inWL = !!byTitle(list, productTitle);

    btn.innerHTML = (inWL
      ? heartFilledSVG() + '<p class="wishlist_text">In Your Wishlist</p>'
      : heartEmptySVG()  + '<p class="wishlist_text">Add to Wishlist</p>');
  }

  // --- collection card toggle
  function toggleWishlistFromCollection(title, img, price, url) {
    var list = getList();
    var existing = byTitle(list, title);

    if (existing) {
      list = list.filter(function (i) { return i.productTitle !== title; });
    } else {
      list.push({ productTitle: title, productImg: img, productPrice: price, productUrl: url });
    }
    setList(list);

    var btn = Array.prototype.slice.call(document.querySelectorAll(".wishlist_button--collection"))
      .find(function (b) { return b.getAttribute("data-product-title") === title; });
    if (btn) btn.innerHTML = existing ? heartEmptySVG() : heartFilledSVG();
  }

  // --- render wishlist page
  function renderWishlist() {
    var wrap = document.querySelector(".js-wishlistBlock");
    var empty = document.querySelector(".js-wishlistEmpty");
    if (!wrap || !empty) return;

    var list = getList().filter(function (i) {
      return i && i.productTitle && i.productImg && i.productUrl;
    });
    setList(list);

    if (!list.length) {
      wrap.style.display = "none";
      empty.style.display = "block";
      wrap.innerHTML = "";
      return;
    }

    wrap.style.display = "flex";
    empty.style.display = "none";

    var mobile = wrap.dataset.mobileCount || 2;
    var desk = wrap.dataset.desktopCount || 4;
    var tablet = desk == 4 ? 3 : 2;

    wrap.innerHTML = list.map(function (item) {
      var safeTitle = item.productTitle.replace(/"/g, "&quot;").replace(/</g, "&lt;");
      return (
        '<div class="Grid__Cell 1/' + mobile + '--phone 1/' + tablet +
        '--tablet-and-up 1/' + desk + '--desk">' +
          '<div class="ProductItem">' +
            '<div class="ProductItem__Wrapper">' +
              '<a href="' + item.productUrl + '" class="ProductItem__ImageWrapper">' +
                '<img class="ProductItem__Image" src="' + item.productImg + '" alt="' + safeTitle + '">' +
              '</a>' +
              '<div class="ProductItem__Info">' +
                '<h2 class="ProductItem__Title Heading">' +
                  '<a href="' + item.productUrl + '">' + safeTitle + '</a>' +
                '</h2>' +
                '<button class="Button Button--secondary ProductItem__Remove" ' +
                  'onclick="removeFromWishlist(\'' + safeTitle.replace(/'/g, "\\'") + '\')">' +
                  'Remove from Wishlist</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join("");
  }

  // --- remove (used on wishlist page)
  function removeFromWishlist(productTitle) {
    var list = getList().filter(function (i) { return i.productTitle !== productTitle; });
    setList(list);
    renderWishlist();
  }

  // --- init
  document.addEventListener("DOMContentLoaded", function () {
    var titleEl = document.querySelector("[data-product-title]");
    if (titleEl) updateWishlistButtonState((titleEl.textContent || "").trim());
    renderWishlist();
  });

  // --- expose to global for inline onclick=
  window.toggleWishlist = toggleWishlist;
  window.updateWishlistButtonState = updateWishlistButtonState;
  window.toggleWishlistFromCollection = toggleWishlistFromCollection;
  window.removeFromWishlist = removeFromWishlist;
})();
